import { useState } from "react";
import { Icon } from "@src/components/Icon";
import { useUnistyles } from "react-native-unistyles";

interface CoverImageProps {
  uri: string;
}

export function CoverImage({ uri }: CoverImageProps) {
  const [failedUri, setFailedUri] = useState<string>();
  const hasError = failedUri === uri;
  const { theme } = useUnistyles();

  if (hasError) {
    return (
      <div
        style={{
          width: "100%",
          height: "100%",
          backgroundColor: theme.colors.muted as string,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          gap: theme.spacing.sm,
        }}
      >
        <Icon name="cloudOff" size={theme.spacing["5xl"]} color={theme.colors.textMuted as string} />
        <span
          style={{
            color: theme.colors.textMuted as string,
            fontSize: 11,
          }}
        >
          Temporarily unavailable
        </span>
      </div>
    );
  }

  return (
    <img
      src={uri}
      alt=""
      onError={() => setFailedUri(uri)}
      loading="lazy"
      decoding="async"
      style={{
        width: "100%",
        height: "100%",
        objectFit: "cover",
        display: "block",
      }}
    />
  );
}
